import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '2048游戏的基本规则是什么？',
    answer: '2048是一款在4×4方格棋盘上进行的数字益智游戏。玩家通过向上下左右四个方向滑动，使所有方块向该方向移动。当两个相同数字的方块碰撞时，它们会合并成一个新方块（数字相加）。每次有效滑动后，棋盘随机空格会生成一个新的数字方块（90%为2，10%为4）。游戏目标是合成2048方块，但可以继续挑战更高数字。',
  },
  {
    question: '如何在2048中获得高分？',
    answer: '获得高分的关键在于三点：一是坚持使用角落策略，将最大数字固定在棋盘的一个角落；二是掌握蛇形排列法，让方块从大到小有序排列；三是严格遵守三方向原则，主要使用两个方向操作。此外，日常的系统化训练和复盘分析也是提升分数的有效方法。',
  },
  {
    question: '为什么我总是很快就游戏结束了？',
    answer: '最常见的原因是操作缺乏计划性。很多玩家习惯"四处滑动"，导致方块散乱，空位迅速减少。解决方案是：选择一个角落固定最大数字，养成每次滑动前思考的习惯，避免使用"向上"等会破坏排列的方向。建议从我们的"核心玩法"分类开始系统学习。',
  },
  {
    question: '蛇形排列法是什么？适合新手使用吗？',
    answer: '蛇形排列法是将方块按照"S"形或反"S"形排列的进阶策略——第一行从左到右递减，第二行从右到左递减，以此类推。这种方法能高效利用整个棋盘空间。建议先熟练掌握角落策略后再学习蛇形排列法，大约在能稳定合成1024时开始练习较为合适。',
  },
  {
    question: '2048核基地提供哪些学习资源？',
    answer: '2048核基地提供五大分类的系统化攻略内容：核心玩法（基础规则和操作）、高分技巧（训练方法和分数提升）、合并策略（角落策略、蛇形排列等经典打法）、进阶秘籍（逆向思维、残局翻盘等高级技巧）、极限挑战（4096攻略和极限模式技巧）。所有内容由资深玩家和策略分析师编写。',
  },
  {
    question: '能达到4096甚至更高吗？',
    answer: '当然可以！虽然挑战巨大，但全球已有不少玩家成功达成4096。关键是掌握蛇形排列法、保持极致的耐心和专注力，以及在有限空位中进行精确操作的能力。建议在能连续稳定合成2048（通关率>80%）后，再开始挑战4096。我们的"极限挑战"分类提供了完整攻略。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于2048玩法和本站资源，你可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}